export default __webpack_public_path__ + "static/media/carousel_3_1280.53b39c43.webp";